var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "download_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 18,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 2a.7.7 0 1 0-1.4 0v8.84L6.259 8.797a.7.7 0 1 0-.99.99l3.176 3.176a.7.7 0 0 0 .99 0l3.176-3.176a.7.7 0 0 0-.99-.99L9.7 10.72V2Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.77a.7.7 0 0 1 .7.7v1.058a1.417 1.417 0 0 0 1.417 1.417h11.646a1.417 1.417 0 0 0 1.417-1.417v-1.059a.7.7 0 1 1 1.4 0v1.059a2.817 2.817 0 0 1-2.817 2.817H3.117A2.817 2.817 0 0 1 .3 13.528v-1.059a.7.7 0 0 1 .7-.7Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#download_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16-16h50v50h-50v-50Z"
  }))));
};

export default SvgDownload;